import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const NAV_LINKS = [
  { label: '首页', to: '/' },
  { label: '热议广场', to: '/topics' },
  { label: '关于我们', to: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || location.pathname !== '/'
          ? 'bg-background-50/95 backdrop-blur border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <Link
          to="/"
          className={`flex items-center gap-2 cursor-pointer ${scrolled || location.pathname !== '/' ? 'text-foreground-950' : 'text-background-50'}`}
        >
          <span className={`w-9 h-9 flex items-center justify-center rounded-md ${scrolled || location.pathname !== '/' ? 'bg-primary-500 text-background-50' : 'bg-background-50 text-primary-600'}`}>
            <i className="ri-fire-line text-lg"></i>
          </span>
          <span className="font-heading text-lg md:text-xl font-bold tracking-wide">网报吃瓜</span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {NAV_LINKS.map((link) => {
            const active = location.pathname === link.to;
            return (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  scrolled || location.pathname !== '/'
                    ? active
                      ? 'text-primary-600'
                      : 'text-foreground-700 hover:text-primary-600'
                    : active
                      ? 'text-background-50'
                      : 'text-background-100/80 hover:text-background-50'
                }`}
              >
                {link.label}
              </Link>
            );
          })}
          <Link
            to="/topics"
            className="px-5 py-2 rounded-md bg-accent-500 text-foreground-950 text-sm font-semibold hover:bg-accent-400 transition-colors cursor-pointer whitespace-nowrap"
          >
            围观热榜
          </Link>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setOpen((v) => !v)}
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer ${scrolled || location.pathname !== '/' ? 'text-foreground-900' : 'text-background-50'}`}
        >
          <i className={open ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'}></i>
        </button>
      </nav>

      {open && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70 px-4 py-4 flex flex-col gap-1">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className="py-3 px-2 rounded-md text-sm font-medium text-foreground-800 hover:bg-background-100 cursor-pointer"
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/topics"
            className="mt-2 py-3 rounded-md bg-accent-500 text-foreground-950 text-sm font-semibold text-center cursor-pointer"
          >
            围观热榜
          </Link>
        </div>
      )}
    </header>
  );
}